import type { ReactNode } from 'react'

interface EmptyStateProps {
  icon: ReactNode
  title: string
  message: string
  action?: {
    label: string
    onClick: () => void
  }
}

export default function EmptyState({ icon, title, message, action }: EmptyStateProps) {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="text-faintest">{icon}</div>
        <h3 className="text-base font-semibold text-subtle">{title}</h3>
        <p className="max-w-sm text-sm text-muted">{message}</p>
        {action && (
          <button
            type="button"
            onClick={action.onClick}
            className="mt-2 rounded-md border border-[color:var(--accent-info)] px-4 py-1.5 text-sm font-medium text-[color:var(--text-info-strong)] transition-colors hover:bg-[color:var(--surface-info-subtle)] focus:outline-none focus:ring-2 focus:ring-[color:var(--accent-info)] focus:ring-offset-1 focus:ring-offset-[color:var(--bg-default)]"
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  )
}
